import React from 'react';
import cn from 'bem-cn';

import { useImageLoad } from '../BackgroundImage/BackgroundImage.hooks';
import { ImageWithFadeInProps } from './ImageWithFadeIn.types';

import './ImageWithFadeIn.scss';

const b = cn('image-with-fade-in');

export const ImageWithFadeIn: React.FC<ImageWithFadeInProps> = ({
    src,
    alt = '',
    className,
    duration = 0.5,
    style,
    ...restProps
}) => {
    const isLoaded = useImageLoad(src);

    return (
        <img
            {...restProps}
            src={src}
            alt={alt}
            className={b({ loaded: isLoaded }).mix(className)}
            style={
                {
                    ...style,
                    '--fade-duration': `${duration}s`,
                } as React.CSSProperties
            }
        />
    );
};
